import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Language {
  code: string;
  name: string;
  flag: string;
}

const languages: Language[] = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' }
];

interface LanguageSwitcherProps {
  isScrolled?: boolean;
}

export default function LanguageSwitcher({ isScrolled = false }: LanguageSwitcherProps) {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  
  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center px-3 py-2 rounded-lg transition-all duration-300 hover:bg-gray-100 ${
          isScrolled ? 'text-gray-700' : 'text-white hover:bg-white/10'
        }`}
      >
        <span className="mr-2 text-lg">{currentLanguage.flag}</span>
        <span className="text-sm font-medium mr-1">{currentLanguage.name}</span>
        <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${
          isOpen ? 'rotate-180' : ''
        }`}></i>
      </button>
      
      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute top-full right-0 mt-2 w-48 bg-white rounded-lg shadow-xl border z-20 py-2">
            {languages.map((language) => (
              <button
                key={language.code}
                onClick={() => handleLanguageChange(language.code)}
                className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-50 transition-colors duration-200 flex items-center ${
                  language.code === i18n.language ? 'bg-emerald-50 text-emerald-600' : 'text-gray-700'
                }`}
              >
                <span className="mr-3 text-lg">{language.flag}</span>
                <span className="font-medium">{language.name}</span>
                {language.code === i18n.language && (
                  <i className="ri-check-line ml-auto text-emerald-600"></i>
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}